import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth, db } from '../assets/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import i18n from 'i18next';
const UserContext = createContext();
export const useUser = () => useContext(UserContext);
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (currentUser) {
        const docRef = doc(db, 'users', currentUser.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setUserData({
            uid: currentUser.uid,
            ...data,
          });
          if (data.lang) {
            i18n.changeLanguage(data.lang);
          }
        } else {
          setUserData(null);
        }
      } else {
        setUserData(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);
  const updateUserData = async (fieldsToUpdate) => {
    if (!user || !user.uid) {
      console.error('No hay usuario autenticado para actualizar.');
      throw new Error('User not authenticated.');
    }
    try {
      const userDocRef = doc(db, 'users', user.uid);
      await updateDoc(userDocRef, fieldsToUpdate);
      setUserData((prevData) => ({
        ...prevData,
        ...fieldsToUpdate,
      }));
    } catch (error) {
      console.error('Error al actualizar los datos del usuario:', error);
      throw error;
    }
  };
  return (
    <UserContext.Provider value={{ user, userData, loading, updateUserData }}>
      {children}
    </UserContext.Provider>
  );
};
